export const mainContainerStyles = { padding: '16px 16px 0 16px' };

export const dividerStyles = { marginTop: '20px' };

export const flexContainer = { display: 'flex' };

export const leftContainerStyle = {
  flex: '1',
  display: 'flex',
  alignItems: 'center',
  fontSize: '20px',
  lineHeight: '26px',
};
